// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"576b8bd5","703":"6b9dac57","787":"d451c7cf"}[chunkId] + ".chunk.js";
};